import { render, staticRenderFns } from "./humanRightsPredictiveRisk.vue?vue&type=template&id=54688d84"
import script from "./humanRightsPredictiveRisk.vue?vue&type=script&lang=js"
export * from "./humanRightsPredictiveRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports